import Env from '../base/env';
import { module } from 'modujs';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-esm/ScrollTrigger';
import { getViewport } from '../utils/utilities';
gsap.registerPlugin(ScrollTrigger);

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };

    this.makeSticky();
  }

  makeSticky() {
    this.sticky = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: 'top top',
      pin: true,
      pinSpacing: false,
      end: () => {
        const viewport = getViewport();
        return `+=${viewport.height}px`;
      },
      invalidateOnRefresh: true,
    });
  }

  destroy() {
    if (typeof this.sticky != 'undefined') {
      this.sticky.kill();
    }
  }
}
